<template>
  <div>
    <div class="landscape">
      <div class="maproom">
        <transition name="fade">
          <div class="maproom-glow glowing-mobile" v-show="isMobile"></div>
        </transition>

        <transition name="fade">
          <div class="onRelease1 img-background" v-show="onRelease1"></div>
        </transition>
        <transition name="fade">
          <div class="onLibrary img-background" v-show="onLibrary"></div>
        </transition>
        <transition name="fade">
          <div class="onCockpit img-background" v-show="onCockpit"></div>
        </transition>
        <div
          class="release1"
          @mouseover="
            onRelease1 = true;
            $store.commit('setToPlace', 'check_release_one');
          "
          @mouseleave="
            onRelease1 = false;
            $store.commit('setToPlace', '...');
          "
          @click="toggleRelease(1)"
        ></div>

        <router-link to="/library">
          <div
            class="tolibrary"
            @mouseover="
              $store.commit('setToPlace', 'to_library');
              onLibrary = true;
            "
            @mouseleave="
              onLibrary = false;
              $store.commit('setToPlace', '...');
            "
          ></div>
        </router-link>
        <router-link to="/cockpit">
          <div
            class="tocockpit"
            @mouseover="
              $store.commit('setToPlace', 'to_cockpit');
              onCockpit = true;
            "
            @mouseleave="
              onCockpit = false;
              $store.commit('setToPlace', '...');
            "
          ></div>
        </router-link>
        <Portal></Portal>
      </div>

      <Releases
        @closePopup="toggleRelease(0)"
        v-if="showRelease > 0"
        :showRelease="showRelease"
      ></Releases>
    </div>
    <div class="portrait">
      <NotOriented></NotOriented>
    </div>
  </div>
</template>

<script>
import Releases from "./releases/Releases";
import Portal from "./Portal";
import MainMixin from "@/components/utilities/MainMixin.vue";
import NotOriented from "@/components/mobile/NotOriented";

export default {
  name: "MapRoom",
  title: "Maproom",
  components: {
    Portal,
    Releases,
    NotOriented,
  },
  mixins: [MainMixin],
  data() {
    return {
      onRelease1: false,
      onLibrary: false,
      onCockpit: false,
      showRelease: 0,
    };
  },
  mounted() {
    this.init();
    let newMsg = {
      text:
        "Hmm the maproom.. here you'll find more infos on the orbital care package you got your hands on, and about where we're at in space.",
      delay: 7000,
    };

    this.$store.commit("setWanerMsg", newMsg);
    window.addEventListener("keyup", (e) => this.eventClose(e));
  },
  destroyed() {
    window.removeEventListener("keyup", (e) => this.eventClose(e));
  },
  methods: {
    toggleRelease(id) {
      this.$store.commit("focusOnStuff");
      this.showRelease = id;
    },
    eventClose(e) {
      if (e.key === "Escape") {
        if (this.showRelease !== 0) this.toggleRelease(0);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.maproom {
  top: 0px;
  left: 0px;
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
  max-height: 100vh;
  background-image: url("../../assets/medias/images/maproom.jpg");
  background-size: 100vw 100vh;
  background-color: black;
}

.maproom-glow {
  top: 0px;
  left: 0px;
  min-width: 100vw;
  min-height: 100vh;
  background-image: url("../../assets/medias/images/maproom-glow.jpg");
  background-size: 100vw 100vh;
}

.onRelease1 {
  background-image: url("../../assets/medias/images/releases/releaseOne.jpg");
}
.onLibrary {
  background-image: url("../../assets/medias/images/maproomToLibrary.jpg");
}
.onCockpit {
  background-image: url("../../assets/medias/images/maproomToCockpit.jpg");
}

.release1 {
  position: absolute;
  top: 47vh;
  height: 18vh;
  width: 10vw;
  left: 34vw;
}

.tolibrary {
  position: absolute;
  height: 40vh;
  width: 20vw;
  top: 35vh;
  left: 7vw;
}

.tolibrary:hover {
  cursor: url("../../assets/medias/images/cursor-left.png"), pointer;
  height: 100%;
}
.tocockpit {
  position: absolute;
  height: 40vh;
  width: 20vw;
  top: 35vh;
  right: 0;
}

.tocockpit:hover {
  cursor: url("../../assets/medias/images/cursor-right.png"), pointer;
  height: 100%;
}
</style>
